const initializeFlickity = () => {
  const slider = document.querySelector('.carousel')

  if(slider) {
    new Flickity(slider, {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: 2000,
      pauseAutoPlayOnHover: true,
      contain: true,
    })
  }
}

export default  initializeFlickity